export default __webpack_public_path__ + "static/media/hands-presenting-straight.560c3ec6.png";